import React, { useEffect, useState } from 'react';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import {IVacancyFull, resumesVacancyPagination} from '../../types/vacancy/IVacancyFull';
import vacansyService from '../../api/vacancy.api';
import ManageTable from '../../components/manageTable/ManageTable';
import SelectCandidateModal from '../../components/modals/SelectCandidateModal';
import ResumeStep from './components/ResumeStep';
import ResumeOperationList from './components/ResumeOperationList';
import { ROUTES } from '../../helpers/routeConsts';
import { useTranslation } from 'react-i18next';
import VacancyFilter from "./components/Vacancy-filter";
import {AxiosResponse} from "axios";
import CustomPagination from "../../components/pagination";
import DownloadResumes from '../../components/downloadResumes';

type Props = {
    showComments: boolean;
};

export type VacancyFilterType = {
    email?: string;
    phone?: string;
    page?: number;
    limit?: number;
}

const ITEMS_PER_PAGE = 40;

const Candidats = (props: Props) => {
    const { id, resumeId } = useParams();
    const [vacancy, setVacancy] = useState<IVacancyFull | null>(null);
    const { t } = useTranslation(); // Инициализация хука для локализации
    const [currentPage, setCurrentPage] = useState(1);
    const [formFilters, setFormFilters] = useState<VacancyFilterType>({
        email: '',
        phone: '',
        page: 1,
        limit: ITEMS_PER_PAGE,
    })

    const update = async (params?: VacancyFilterType, page?: number) => {
        if (page) {
            setCurrentPage(page)
            setFormFilters((prev) => ({
                ...prev,
                page,
            }));
        }
        return vacansyService.findByIdShort(Number(id), {...params}).then((response: AxiosResponse<IVacancyFull>) => {
            setVacancy(response.data);
        }).catch((e: any) => {
            console.error(e);
        });
    };

    useEffect(() => {
        update(formFilters);
    }, [id]);

    const location = useLocation();
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(ROUTES.CANDIDATE_CREATE, { state: { path: location.pathname } });
    };

    const handleStatusChange = async (isRead?: {id: number, isRead: boolean} | null) => {
        if (!isRead || !id || isRead.isRead) return
        vacansyService.updateVacancyRead(isRead.id)
    };

    const handleChangePage = async (page: number) => {
        setCurrentPage(page);
        await update({...formFilters, page}, page)
    };

    const resumes = vacancy?.resumes as any as resumesVacancyPagination
    const allResumesId = resumes?.value?.map(item => item.id)
    return vacancy && (
        <>
            <h4 className='mb-3'>{t('candidates.title')} {vacancy.position}</h4>

            <div className={'d-flex gap-4'}>
                <SelectCandidateModal vacancy={vacancy} update={update}/>

                <button onClick={handleClick} className='btn btn-primary mb-3'>
                    {t('AddCandidateButton')}
                </button>
                <DownloadResumes resumeIds={allResumesId} disabled/>
            </div>


            <ManageTable
              title={t('candidates.tableTitle')}
              header={
                <div className={'flex gap-4 items-center'}>Всего кандидатов: {resumes?.count}
                  <VacancyFilter
                      afterFilter={update}
                      formFilters={formFilters}
                      setFormFilters={setFormFilters}
                  />
                </div>
            }
              footer={<></>}
              pages={[]}
            >
            <thead>
                    <tr>
                        <th>{t('candidates.tableHeaders.name')}</th>
                        <th>{t('candidates.tableHeaders.status')}</th>
                        <th>{t('candidates.tableHeaders.stageDate')}</th>
                        <th>{t('candidates.tableHeaders.stage')}</th>
                        <th>{t('candidates.tableHeaders.operations')}</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        resumes && resumes.value.length > 0 && resumes.value.map((item) => {
                            return (
                              <tr key={item.id}>
                                  <td><Link
                                      onClick={() => handleStatusChange(item?.readStatus)}
                                      className={item?.readStatus?.isRead === false ? 'text-lg font-bold' : ''}
                                    to={ROUTES.CANDIDATE_INFO + "/" + item.candidate.id}>{item.candidate.firstName} {item.candidate.lastName}</Link>
                                  </td>
                                  <ResumeStep
                                    resumeId={Number(item.id)}
                                    candidate={item.candidate}
                                    vacancyId={vacancy.id}
                                  />
                                  <td><ResumeOperationList candidate={item?.candidate} resumeId={Number(item.id)} vacancyId={vacancy.id}
                                                           update={() => update(formFilters)} showComments={props.showComments}
                                                           showCommentsFor={resumeId}/></td>
                              </tr>
                            );
                      })
                    }
                </tbody>
            </ManageTable>
            <CustomPagination
                currentPage={currentPage}
                totalItems={resumes?.count || 0}
                itemsPerPage={ITEMS_PER_PAGE}
                onPageChange={handleChangePage}
                labelOnPage={resumes?.value?.length}
            />
        </>
    );
};

export default Candidats;
